module.exports = __webpack_public_path__ + "media/country_flags/ax-37fd64cc.png";